import { useCallback } from "react";
import useGameStore from "@store/useGameStore";
import { getGame } from "@/api/gameApi";
// ✅ Ya no se necesita 'useAuthStore' aquí.

/**
 * Hook que PROVEE la lógica de carga para la vista del juego.
 */
export default function useGame() {
    
    const fetchGameById = useCallback(async (gameId) => {
        // Obtenemos las acciones del store en el momento de la ejecución.
        const setLoading = useGameStore.getState().setLoading;
        const setError = useGameStore.getState().setError;

        if (!gameId) {
            console.warn("[useGame] No se encontró gameId, saltando la carga.");
            return;
        }

        setLoading(true);
        try {
            
            await getGame(gameId);
        } catch (err) {
            setError(err.userMessage || "No se pudieron cargar los datos del juego.");
        }
    }, []);

    // El hook solo devuelve la función.
    return { fetchGameById };
}